import { render } from "./Facturacion.vue?vue&type=template&id=36fe1b83"
import script from "./Facturacion.vue?vue&type=script&lang=js"
export * from "./Facturacion.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__